import { AuroraAwhpStatus } from '../types'

export class AuroraAwhpActionNack extends Error {
  constructor(message: AuroraAwhpStatus['action_nack']) {
    super(message)
  }
}

export default AuroraAwhpActionNack
